module.exports = "/fonts/vendor/material-icons/iconmaterial-icons-two-tone.woff?87a93d696c7bd838f060276647a0146b";